import classNames from "classnames";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge ships a static, hardcoded map of *default* Tailwind class
// names per group -- it never reads this project's tailwind.css/@theme. For
// fixed-enum groups (font-size, box-shadow, etc.) any custom-named theme
// token we add isn't in that map, and falls through to a more permissive
// group's matcher instead (e.g. any unrecognized "text-*" utility looks like
// a text-color class to it). Left unconfigured, combining one of our custom
// tokens with a real color utility in the same cn() call makes twMerge think
// they conflict and silently drop whichever came first -- deleting the
// font-size/shadow instead of resolving an actual conflict. Registering them
// under their real group fixes classification (and makes them correctly
// conflict with real same-group utilities, e.g. text-[13px], instead).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "micro",
            "caption",
            "small",
            "body",
            "body-lg",
            "heading",
            "heading-lg",
            "title",
            "display",
          ],
        },
      ],
      shadow: ["shadow-box-shadow", "shadow-box-shadow-inset"],
    },
  },
});

// Combines classNames()'s conditional-class ergonomics with tailwind-merge's
// conflict resolution: when two classes target the same CSS property (e.g.
// "relative"+"absolute", "bg-[#999]"+"bg-[#0f6]", "px-2"+"px-3.75"), the one
// passed LAST wins, deterministically -- rather than leaving it up to
// Tailwind's generated-CSS source order, which isn't guaranteed to match the
// order these were written in and has repeatedly picked the wrong class.
export function cn(...inputs: Parameters<typeof classNames>) {
  return twMerge(classNames(...inputs));
}
